import React, {PropsWithChildren} from 'react';
import {EmptySection} from '@/status_pages/display/EmptySection';

export interface EmptySectionRocketProps extends PropsWithChildren {}

export const EmptySectionRocket = ({children}: EmptySectionRocketProps) => {
  return <EmptySection icon={<i className="far fa-rocket-launch"></i>}>{children}</EmptySection>;
};
